export function dismissLcpHeroShell() {
  if (typeof document === "undefined") return;
  const shell = document.getElementById("lcp-hero-shell");
  if (shell) {
    shell.classList.add("lcp-hero-shell--hidden");
  }
}

export function dismissLcpHeaderShell() {
  if (typeof document === "undefined") return;
  const shell = document.getElementById("lcp-header-shell");
  if (shell) {
    shell.classList.add("lcp-header-shell--hidden");
  }
}

export function isLcpHeroShellVisible() {
  if (typeof document === "undefined") return false;
  const shell = document.getElementById("lcp-hero-shell");
  return Boolean(shell && !shell.classList.contains("lcp-hero-shell--hidden"));
}

export function preloadHeroImage(url) {
  if (!url || typeof document === "undefined") return;
  if (document.querySelector(`link[rel="preload"][as="image"][href="${CSS.escape(url)}"]`)) return;

  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = url;
  link.setAttribute("fetchpriority", "high");
  document.head.appendChild(link);
}
